module.exports = __webpack_public_path__ + "static/media/gray_09.ca3229f1.jpg";